import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getList = () => {
    return axios.get(`/api/devicegroups`, {headers: authHeader()})
        .then(res => {
            return res.data
        });
};

const getDropDownList = () => {
    return axios.get(`/api/devicegroups/getDropdownList`, { headers: authHeader() })
        .then(res => { return res.data })
};

const getElementById = (deviceGroupId) => {
    return axios.get(`/api/devicegroups/${deviceGroupId}`,  { headers: authHeader() } )
        .then(res => { return res.data })
};

const changeOrder = (deviceId, direction) => {
    return axios.patch(`/api/devicegroups/${direction}/${deviceId}`, {}, {headers: authHeader()})
        .then(res => {
            return res.data
        });
};

const addDeviceGroup = (deviceGroup) => {
    return axios.post(`/api/devicegroups`, deviceGroup, {headers: authHeader()})
        .then(res => {
            return res.data
        })
};

const editDeviceGroup = (deviceGroup) =>  {
    return axios.patch(`/api/devicegroups/${deviceGroup.id}`, deviceGroup, {headers: authHeader()})
        .then(res => {
            return res.data;
        })
};

const assignToGroup = (deviceGroupId, networkDeviceList) => {
    return axios.put(`/api/deviceGroups/${deviceGroupId}`, networkDeviceList, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const removeDeviceGroup = (deviceGroupId) => {
    return axios.delete(`/api/devicegroups/${deviceGroupId}`, {headers:authHeader()})
        .then(res => {
            return res.data;
        })
};

export const deviceGroupService = {
    getList,
    getDropDownList,
    getElementById,
    addDeviceGroup,
    editDeviceGroup,
    removeDeviceGroup,
    assignToGroup,
    changeOrder
};
